
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as lmscjDJDHuk3W1z5_45iyGLTqEL3819TsqWIi0TFtD0kDyCYMeta } from "/vercel/path0/pages/lms.vue?macro=true";
import { default as homekwnicJK2nHG5PwZCTvdumsTAvd8POoBPlKW0JMmtxqUMeta } from "/vercel/path0/pages/home.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as convert4J22McIwWtnOn_458aBZ5uj2z_45eH2pG5ATmUp5EakzlLgMeta } from "/vercel/path0/pages/convert.vue?macro=true";
import { default as indexv1fFzc2ShcljiGo28Bo2KD8xzvwNrH7uZVZ3jm__I8gMeta } from "/vercel/path0/pages/settings/index.vue?macro=true";
import { default as reportsEV96Bre922sUS_45OT5HiNdhWW0f3mO_lh38ioAFaWY_454Meta } from "/vercel/path0/pages/settings/reports.vue?macro=true";
import { default as app_45datawcFHXqZ_JjGd_45q40wetIu7UyCAZ7_pw5fKBRfC_4572pkMeta } from "/vercel/path0/pages/settings/app-data.vue?macro=true";
import { default as checklistswD_oiDLvHPHuMZoyCkrjLAeKSsgyq2IaDNbjNJZ_80AMeta } from "/vercel/path0/pages/settings/checklists.vue?macro=true";
import { default as finalizeOxoAV0su_45JhexXF57SjDzo14HGXvZbmjt_45DcfzqVnakMeta } from "/vercel/path0/pages/settings/lms/finalize.vue?macro=true";
import { default as settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta } from "/vercel/path0/pages/settings.vue?macro=true";
import { default as error7aJnlxSXva_84_45uSJHuryCvUpxClEg13N9T8YKzbZucMeta } from "/vercel/path0/pages/auth/error.vue?macro=true";
import { default as LoginfVE33oaYj40Hd1ZJtUvDF8XwCjzj82HdOPiTw_45afx3UMeta } from "/vercel/path0/pages/auth/Login.vue?macro=true";
import { default as oauthhHYTNVx0E8FXOH7Qln8mwxQiGGhkFhgbiaJmN9v3To4Meta } from "/vercel/path0/pages/auth/oauth.vue?macro=true";
import { default as RegisterPdBS76zBF_45_456fR7e7ZqEoCWHNQYFkxT_45JAq4LQ_45u5BkMeta } from "/vercel/path0/pages/auth/Register.vue?macro=true";
import { default as usage1T6znCMg7EIfuh2aaszXBlVPFpCr_45oH1yMC12huHWGsMeta } from "/vercel/path0/pages/reports/usage.vue?macro=true";
import { default as stylen5YpnFYT3i0eUGj_NHEKjA6fg9PzwZ66xVqWk8a_45rkUMeta } from "/vercel/path0/pages/students/home/style.vue?macro=true";
import { default as grades3z1ups_45P13lkgTQakbeEBsokVJjr0xvBrVTYBlr7AP8Meta } from "/vercel/path0/pages/students/home/grades.vue?macro=true";
import { default as resourcesmjXzBP5FUucMmhUhFqmVhNfscfj7z_fCMhR_45OlDaogIMeta } from "/vercel/path0/pages/students/home/resources.vue?macro=true";
import { default as assignmentsVJ_45oK2NGgF9_452hWs5VP83Wyvmwk2m8ZcB85XXcUJYR0Meta } from "/vercel/path0/pages/students/home/assignments.vue?macro=true";
import { default as home_LCBUNLP3_455CZE62hdfTTc7dYw1WEuEhXLECv1gYeA0Meta } from "/vercel/path0/pages/students/home.vue?macro=true";
import { default as testurvX8agrX0cEObSE_a4_45jLz2VRqPBFYYSBep6eM9_453gMeta } from "/vercel/path0/pages/admin/lms/test.vue?macro=true";
import { default as index0f8JRB9cR_4501TW1jzlinuL4Z4mObPIqkaQTdKquio18Meta } from "/vercel/path0/pages/articles/index.vue?macro=true";
import { default as messageXjyL2A9MSOp1CYcjind5kE3PjPkH0Irl3wowJcAArjAMeta } from "/vercel/path0/pages/errors/message.vue?macro=true";
import { default as errorrh4RceNzI1Y_YVainYYz71GtVXfLLs5gREh_455lppOk4Meta } from "/vercel/path0/pages/students/error.vue?macro=true";
import { default as indexUgSxJh2cQMyZBsE6m_450EFffw_kDnun59m7HC0AxonJ8Meta } from "/vercel/path0/pages/students/index.vue?macro=true";
import { default as marketingU02c6YJsKV1Mq0otCI6gGok7_45r7oGRTEs0ttYBvihC8Meta } from "/vercel/path0/pages/test/marketing.vue?macro=true";
import { default as dashboardJLgY_45pk63kzMCm9yuqJ3BxnQlJZRCEqjWncRiulWHP8Meta } from "/vercel/path0/pages/admin/dashboard.vue?macro=true";
import { default as demo_45loginQYtrOPBKetkPN1wbryopSt6bZiq6kTq5CvdIsX10JAoMeta } from "/vercel/path0/pages/auth/demo-login.vue?macro=true";
import { default as addFZZlWIiFRcOyJuUBYdmz5ka9igaWc5cpA07_9f_459fvgMeta } from "/vercel/path0/pages/manage/roles/add.vue?macro=true";
import { default as problemsZSFncibcFNcL52HeFP4SbChnirhEBOU9Qur5ccx8Sj0Meta } from "/vercel/path0/pages/reports/problems.vue?macro=true";
import { default as component_45libraryvttlSITWl4jKvj6p2Yulfe2J8jGE2FPkCai1mj6R7HQMeta } from "/vercel/path0/pages/component-library.vue?macro=true";
import { default as addVIhB7E17paUD4BTrjGPsA_45sXEs66wnRFpP_eKFakVAUMeta } from "/vercel/path0/pages/manage/levels/add.vue?macro=true";
import { default as refresh_45tokenxcuO5d_8MYhzeJ3a_45Gafkf5BiIMToZ4Yo7YCsCEArz0Meta } from "/vercel/path0/pages/auth/refresh-token.vue?macro=true";
import { default as passwordot8NV_Z7AQnysEdPa0lqX8mB_45dVnxlNvY7tl9QptpzcMeta } from "/vercel/path0/pages/configure/password.vue?macro=true";
import { default as addAjR3ZDpvXqRNjCLKVYy_BgCXUcUJ_4573oAl4tL4ZW5TEMeta } from "/vercel/path0/pages/manage/lessons/add.vue?macro=true";
import { default as add0NUv_45bA_gff835ClTgGkaJ8RrrnhI5J8pMojZVLe3OkMeta } from "/vercel/path0/pages/manage/metrics/add.vue?macro=true";
import { default as indexoWcVbp9B5iiZOuk5KQ4gT16D3mPGmaRKcOUatfzz4KMMeta } from "/vercel/path0/pages/manage/roles/index.vue?macro=true";
import { default as indexWFdZJu__45GT6esiGMQt1wqub8Vbq56VoXCI_M2fG2C8oMeta } from "/vercel/path0/pages/manage/users/index.vue?macro=true";
import { default as link_45usersZsen3f2q8m6VUBXFn74LPo8tBGIvTUdlTRKetUO7jvEMeta } from "/vercel/path0/pages/reports/link-users.vue?macro=true";
import { default as onboarding6SaNHboq7muZ2lsRJardKRtH3SHlniGxvjnOwhphNeoMeta } from "/vercel/path0/pages/welcome/onboarding.vue?macro=true";
import { default as reset_45password6LLtCEAcDAc7CNK0fd8tOMdP9INZZZLl1DhKX_Z5qEQMeta } from "/vercel/path0/pages/auth/reset-password.vue?macro=true";
import { default as addsCT8E3v1GA8ILeJltu_45DQmOxom9r4YvCG4mlEEtWdIoMeta } from "/vercel/path0/pages/manage/articles/add.vue?macro=true";
import { default as addka8A1w5o62iYaJONmvxBQuq9yiJgLlpBOWERM7MrVx8Meta } from "/vercel/path0/pages/manage/comments/add.vue?macro=true";
import { default as addXKB68OlpyS0k_rI5uERXxS3H5DFTi7YFsPk_l3MmfpEMeta } from "/vercel/path0/pages/manage/criteria/add.vue?macro=true";
import { default as indexZa97_5HcIX4LKi4lYz23Jnjp4RmYlX2AlYMOCTfuSuMMeta } from "/vercel/path0/pages/manage/levels/index.vue?macro=true";
import { default as addokFZD7xfB9jRcDDku4lJEEWe87K_Er7Mten67CoxxJEMeta } from "/vercel/path0/pages/manage/products/add.vue?macro=true";
import { default as zooml_45KzHDmutG7CjdouqA_45cUFHUofmAd7IKomqhDCZGY3AMeta } from "/vercel/path0/pages/oauth/finalize/zoom.vue?macro=true";
import { default as submissions0l2Wc2EXeaIu_45w_45DzyxqQufJg2Lk_45l5gUz80_45yIiPpkMeta } from "/vercel/path0/pages/reports/submissions.vue?macro=true";
import { default as jira7pjEDJ_Qt5_hXfUwILL874iKcenvo07vr52X_45uV6DoMMeta } from "/vercel/path0/pages/reports/tester/jira.vue?macro=true";
import { default as loging_453oAMwA19yaSzuR1MrxyyzfAaynmibJ8aBXR4kRHTsMeta } from "/vercel/path0/pages/students/auth/login.vue?macro=true";
import { default as forgot_45passwordtAto7006olk3T8pxc58b68rnBOq8ZyKBjsUYZLBF0okMeta } from "/vercel/path0/pages/auth/forgot-password.vue?macro=true";
import { default as curriculum6uff9r2XHsGLES9jdq4BvSWvvLaCciTMor_45gFJ9zB08Meta } from "/vercel/path0/pages/configure/curriculum.vue?macro=true";
import { default as chooseiClGVBlUpLEYMrxQfwo9S1Sq0tRZUpvzax_451GqflXq8Meta } from "/vercel/path0/pages/configure/lms/choose.vue?macro=true";
import { default as quick_45keysv64l_45LGmR7hZkgDnA065wul7ByyZoFltlpiDtq1qt7EMeta } from "/vercel/path0/pages/configure/quick-keys.vue?macro=true";
import { default as _91id_93Z_sAvV0Pgt0unGUiCl9ssraKOTLulehICY_45NpzoI6UUMeta } from "/vercel/path0/pages/level/documents/[id].vue?macro=true";
import { default as indexl19Lew7I67g7rkQ6LfIa0_sWvnFWpQ8PU_45EhnrrExpYMeta } from "/vercel/path0/pages/manage/lessons/index.vue?macro=true";
import { default as indexbpIe6nP8Lix0rOnAmJhZ_f86PHLQn4M7YUpirn7JpAsMeta } from "/vercel/path0/pages/manage/metrics/index.vue?macro=true";
import { default as _91version_93IcqsRaRu_Qtxj1d2J8ZnjipV4bz4kie2l61Y472vGe4Meta } from "/vercel/path0/pages/manage/packages/list/[version].vue?macro=true";
import { default as listc_i9WXhzbDO6igKJf3GmmZjXY4E6C8GacjL6elW3RWAMeta } from "/vercel/path0/pages/manage/packages/list.vue?macro=true";
import { default as indexn3oK4ali6sCHe_45u7OwDokkY0SopZNm1uyHH47mD5JaAMeta } from "/vercel/path0/pages/reports/tester/index.vue?macro=true";
import { default as activate_45accountTWZJi9ee2VI82AmV7bnpVc35bmTODXXs5tFKKx7ZVlcMeta } from "/vercel/path0/pages/auth/activate-account.vue?macro=true";
import { default as addHjGerNpUuChDBRHlqEU03KZrG_uD1yUScJyoVlALmNwMeta } from "/vercel/path0/pages/classrooms/emails/add.vue?macro=true";
import { default as indexwUpHcLdZBGXI65v0jMuZV_4598xAQI2auH9DNIKnxTt7gMeta } from "/vercel/path0/pages/manage/articles/index.vue?macro=true";
import { default as add8wTx235yPPHsOnti7ebvXor5TETrE6aF4LnJqgyvmoUMeta } from "/vercel/path0/pages/manage/checklists/add.vue?macro=true";
import { default as indexyfHqh3DUD5bd1_450FSoIZsp2cbQ5uExttMHZUXK4uDNoMeta } from "/vercel/path0/pages/manage/comments/index.vue?macro=true";
import { default as indexNqi9_leApIqq421W5TeQSRkrL8qgC0_45HRWWk5ov3m_45gMeta } from "/vercel/path0/pages/manage/criteria/index.vue?macro=true";
import { default as index8en8QBb646208GH3HXXJewMhPBi6oVGeRJtKTc_9gm8Meta } from "/vercel/path0/pages/manage/products/index.vue?macro=true";
import { default as _91userId_93RUDktGzDmk3_450m9kDROnhmIeUpkQd4ofOLPw0BJgqBkMeta } from "/vercel/path0/pages/manage/users/[userId].vue?macro=true";
import { default as googlec5CFDhrsJxnR3ztG3O4ky0l6gbkd635ciuVZ7C4t_0EMeta } from "/vercel/path0/pages/oauth/finalize/google.vue?macro=true";
import { default as add6yMLCpdhVnZY4bSMj7_45WQxmCfgUVuKmk8MaHQyw0AIgMeta } from "/vercel/path0/pages/configure/comments/add.vue?macro=true";
import { default as finalizejw0cA69nmq4ZBZ7_y2QU6HSUUy2pDrOQBjHog_cnSBIMeta } from "/vercel/path0/pages/configure/lms/finalize.vue?macro=true";
import { default as subscriptiond4soP5_czxQOcXQIMy5eyG2idZXrhKQmJAtFxAXjbMkMeta } from "/vercel/path0/pages/configure/subscription.vue?macro=true";
import { default as addCvwSiB7hqg8dkDEXzB22ft35YSyyEyCH1YJYtgrTozUMeta } from "/vercel/path0/pages/manage/permissions/add.vue?macro=true";
import { default as _91id_93W6GM6Li6Y0cO4IZqtCLmJnOuqrz7K2Aq3WGv07MTfTQMeta } from "/vercel/path0/pages/manage/roles/edit/[id].vue?macro=true";
import { default as cookie_45policyT_4PkKlI8zqiiGqxTjqX0aTPNNF1RiiWLGjsXcXLfeIMeta } from "/vercel/path0/pages/policies/cookie-policy.vue?macro=true";
import { default as documents_45syncHsxg1vNqlWxR_45X5VDHLGp2eQ9xZ0jesIHgh9h7AIreIMeta } from "/vercel/path0/pages/reports/documents-sync.vue?macro=true";
import { default as reviewt3Hiy5n65qAEvx90SrnqHzyNoF_2a63rj5TNT_wmT_45gMeta } from "/vercel/path0/pages/admin/checklists/review.vue?macro=true";
import { default as indexQs76idwmz_455x2sPlAhQdTBXsTTohHgRDqzjCQ7WV_lEMeta } from "/vercel/path0/pages/classrooms/emails/index.vue?macro=true";
import { default as addiNx6x_458GDgS7puOyvvEWGnZUfUN9aK9htEqr1odEyMkMeta } from "/vercel/path0/pages/manage/capabilities/add.vue?macro=true";
import { default as indexyoHKv6pKFUaOzaAO0qq_455ILBWxQ8X0i9g7RwLycqauwMeta } from "/vercel/path0/pages/manage/checklists/index.vue?macro=true";
import { default as wordsQ4wqTXfDQCUyYLbnceR9FfYvtrxKsEhF9QAgH_45mEtjYMeta } from "/vercel/path0/pages/manage/dictionary/words.vue?macro=true";
import { default as _91id_933Y6MccyOQkxDhNF9iJkIFQiDd3jUDu31IXNzNpcKMTkMeta } from "/vercel/path0/pages/manage/levels/edit/[id].vue?macro=true";
import { default as createWQQ904WlktS_459GQ_D4lRBKTLqyWseXA_455tT8j7X7jLQMeta } from "/vercel/path0/pages/order/[cartType]/create.vue?macro=true";
import { default as privacy_45policyWrkuMHLAZZkj72Cp_FqFBQGqOGAKRd1BHeCKlEEg_mkMeta } from "/vercel/path0/pages/policies/privacy-policy.vue?macro=true";
import { default as billing_45history_458SFawUaLZblqnh3NjhIZiH0A4l9IfZQSxz5s9DDD1EMeta } from "/vercel/path0/pages/reports/billing-history.vue?macro=true";
import { default as addA2AQTKRM0rTXEv5_458p_452Xi7VJaRyOI_45zdj08uRFAgGoMeta } from "/vercel/path0/pages/reports/tester/runs/add.vue?macro=true";
import { default as _91studentId_93fliaGWhAJvsehK9nDswTKyJ3JYvMM6sd9akxNZ_45o_E0Meta } from "/vercel/path0/pages/classrooms/[classroomId]/students/[studentId].vue?macro=true";
import { default as students_CvBBBsreVir6Br10qmq8OZU64UNEAdB1SlCLyGj6xYMeta } from "/vercel/path0/pages/classrooms/[classroomId]/students.vue?macro=true";
import { default as addCvY_HEyy0I9t46Ala4_45z6TaIY6nF_g9QFv7K_45zNZ_dMMeta } from "/vercel/path0/pages/classrooms/[classroomId]/emails/add.vue?macro=true";
import { default as _91assignmentId_93kAaSFw54C1A9xNcCdGDThDtucyfJ1i0dxg4213EWRDEMeta } from "/vercel/path0/pages/classrooms/[classroomId]/assignments/[assignmentId].vue?macro=true";
import { default as assignments_L9_452jWIZ91JK5LR0tbXURaHoSl5JMfAUdUeXBZOjqMMeta } from "/vercel/path0/pages/classrooms/[classroomId]/assignments.vue?macro=true";
import { default as index0F_45uTEKGLdlrek4JN_9FsBGr5XwggqifFA_nYJvuUKgMeta } from "/vercel/path0/pages/classrooms/[classroomId]/style/index.vue?macro=true";
import { default as indexqRpFZkDAbDSz7iGBfU23WXP1cr39ijzzy7tEu_45mYvC4Meta } from "/vercel/path0/pages/classrooms/[classroomId]/emails/index.vue?macro=true";
import { default as _91classSessionId_933p6kJ3LJn7jPSelrWILioPAK5LArGvjiRlbNqIjMyxgMeta } from "/vercel/path0/pages/classrooms/[classroomId]/class-sessions/[classSessionId].vue?macro=true";
import { default as class_45sessionsx5LC7P5OQsvsohOW6Oij9Oqvi6w9K4EWCUhduIUGu8wMeta } from "/vercel/path0/pages/classrooms/[classroomId]/class-sessions.vue?macro=true";
import { default as index1LgIEVzLrPCTa7SYNAsImhMGuIyDzQ_4562IABc33BLowMeta } from "/vercel/path0/pages/classrooms/[classroomId]/gradebook/index.vue?macro=true";
import { default as indexHVIt_45TrNgG87jr9d_PWGWwNOshu693NSZpixqtWG7qEMeta } from "/vercel/path0/pages/classrooms/[classroomId]/resources/index.vue?macro=true";
import { default as _91emailId_93_457Rfsm1lqZDoVObbpI8HQLt2T0p0nHAnOcyXdkq1afUMeta } from "/vercel/path0/pages/classrooms/[classroomId]/emails/edit/[emailId].vue?macro=true";
import { default as _91studentId_93mxrn6yghoBR3PM2Jsb4wV_6WAiZTfRuxVRWxOMggbtUMeta } from "/vercel/path0/pages/classrooms/[classroomId]/report-card/[studentId].vue?macro=true";
import { default as _91classroomId_93_458XPuALO4rUc2bVFt7iRQyFq1EYn0lpdrA7d1_O7VBQMeta } from "/vercel/path0/pages/classrooms/[classroomId].vue?macro=true";
import { default as addjYpgS5jY239PV4_7hEQFLS0AEWan9fYbllJgZTnzFioMeta } from "/vercel/path0/pages/configure/classrooms/add.vue?macro=true";
import { default as index6gQvK4fhvfGS7yyhKFliSbBaeZZxJTfQKlVi3EaUJHgMeta } from "/vercel/path0/pages/configure/comments/index.vue?macro=true";
import { default as classroomspTH9dpol6RPz4VLOFI28zg5TzsWNMX7D4l43VQJw4ooMeta } from "/vercel/path0/pages/configure/lms/classrooms.vue?macro=true";
import { default as addqnJN2YwQg2laFGbwtyPGLxpm8ucobmATuctVvqChFiMMeta } from "/vercel/path0/pages/manage/announcements/add.vue?macro=true";
import { default as add6J0289TplDppvvT3K2NEvp2tbnGiatE_XhNCX_456KR_oMeta } from "/vercel/path0/pages/manage/comments/bulk/add.vue?macro=true";
import { default as _91id_93Roe_ui8_45VaSXMZ0vF_9Xl6cQWvMP_45pe9YnIsHxxqxiQMeta } from "/vercel/path0/pages/manage/lessons/edit/[id].vue?macro=true";
import { default as _91id_930UMPcIGC_45uVtpkzgURWVPOeH7SH_45khrieUe7PW1_45LxIMeta } from "/vercel/path0/pages/manage/metrics/edit/[id].vue?macro=true";
import { default as addGXt0qghALI_45bvwcQdsdqlgCXfr2PocgU_45LMN_vhzSWEMeta } from "/vercel/path0/pages/manage/organizations/add.vue?macro=true";
import { default as indexAa3EhgN7aapnJwnlMDe2sEK6YInRLlSgNouyCEcS7skMeta } from "/vercel/path0/pages/manage/permissions/index.vue?macro=true";
import { default as user_45permissionswAUk9uOcD4wouHUz86TNxRMuw_EAzUnzUGv2DwPj9dwMeta } from "/vercel/path0/pages/reports/user-permissions.vue?macro=true";
import { default as _91id_93t1GF8TAT9Ui1aYN8TnU5f9oOVPoenBiB23x_45Lbv1Y9gMeta } from "/vercel/path0/pages/students/lms/emails/[id].vue?macro=true";
import { default as _91articleId_932jVxkC_AAtIgNjdshakDiEU4ZbpNcHENyhLstC_dhV0Meta } from "/vercel/path0/pages/articles/view/[articleId].vue?macro=true";
import { default as assignmentsn0N58vX6RaujCvRhJq_S7NIr7O77s9_45y7S1XUN6CtpYMeta } from "/vercel/path0/pages/configure/lms/assignments.vue?macro=true";
import { default as submissionsts_456AIuCXNq1erYfwLueqYdZGymLfgtiJjoFJiny_y8Meta } from "/vercel/path0/pages/configure/lms/submissions.vue?macro=true";
import { default as _91id_93hL4qPcpzkg1E3f_7pr6ao4pw63LfjEOlfGiwWhovUqcMeta } from "/vercel/path0/pages/manage/articles/edit/[id].vue?macro=true";
import { default as indexjvPUyAnyvmb4nuC8CGeZwhcxnC1I8QP_yr6I86Gzk9wMeta } from "/vercel/path0/pages/manage/capabilities/index.vue?macro=true";
import { default as _91id_93YeGkGJL5mP_459I_458FyvoxOVODlq67EP273C4sLUGYEVEMeta } from "/vercel/path0/pages/manage/comments/edit/[id].vue?macro=true";
import { default as _91id_93xKfKSDJO_45hcbvwsFZJ670dmr0QHFfwGL0TK9HGDsN0YMeta } from "/vercel/path0/pages/manage/criteria/edit/[id].vue?macro=true";
import { default as _91id_93G_45yVh7zoSFnJqv9p0jWeYFxnMLXTPb307XUv__45HcMygMeta } from "/vercel/path0/pages/manage/products/edit/[id].vue?macro=true";
import { default as subscriber_45healthJRCyxObp2RJJxQzaCODX2rjDRdyLQsVjBrY6AxTFhykMeta } from "/vercel/path0/pages/reports/subscriber-health.vue?macro=true";
import { default as indexWCVYEjFOeechjMVXhYhqLgAduc0DNarI5sd0ljoForsMeta } from "/vercel/path0/pages/reports/tester/runs/index.vue?macro=true";
import { default as _91token_93lZpl45myDuTp5crUNQJSenil11Duds4ChZE6v0LQ_YsMeta } from "/vercel/path0/pages/students/activate/[token].vue?macro=true";
import { default as words3K4w32mSGxoI54Yj_45AezzPbDm2FEpIg0jt6sXRxHMc0Meta } from "/vercel/path0/pages/configure/dictionary/words.vue?macro=true";
import { default as submittedXRaatOcG0BoCp_W_KHu0qrRpfHcXlmJPxGyi5UHaRT4Meta } from "/vercel/path0/pages/documents/[mode]/submitted.vue?macro=true";
import { default as indexml3123eyK92qzhwqGPKrEVGvQcZCtNl93Qr5Y2QTIrIMeta } from "/vercel/path0/pages/manage/announcements/index.vue?macro=true";
import { default as addQjzAsYfTY1Ty1hvnEDl_zXlyAgYQzlNFQ0WlDPWy6vsMeta } from "/vercel/path0/pages/manage/criteria/groups/add.vue?macro=true";
import { default as indexN6SD7GAOiDAmUJ_45D3ZPXMFAzezeHkiJuFLmE4SNwP08Meta } from "/vercel/path0/pages/manage/organizations/index.vue?macro=true";
import { default as edit2GSx39OVQwSE2UjsxDhJjL0soWmr6FkZWSveOtZcEVQMeta } from "/vercel/path0/pages/classrooms/emails/[id]/edit.vue?macro=true";
import { default as addJzMcDkaTgNSEwFvpDW_452rRGAIsyoAadhkBR_puYCIfkMeta } from "/vercel/path0/pages/configure/comments/bulk/add.vue?macro=true";
import { default as addqZxdF8xxC5IqHq3TbYKw2sOKU79JGYuSPPqr_45Zb_45z9UMeta } from "/vercel/path0/pages/manage/annotation/types/add.vue?macro=true";
import { default as _91id_93Aha5NFd4KXQPfrI_t7fllvnkKHbfkkUrmdl6bnG4oIsMeta } from "/vercel/path0/pages/manage/checklists/edit/[id].vue?macro=true";
import { default as edit1RNYAhM5wOE82zw1349er2beg6kTn9GZbo5GuVdiBLAMeta } from "/vercel/path0/pages/configure/comments/[id]/edit.vue?macro=true";
import { default as indexW3tyekdCSg51wAVoCHACdQpx4NAcDBCkPM3_45tUya2PEMeta } from "/vercel/path0/pages/manage/criteria/groups/index.vue?macro=true";
import { default as _91id_934Mn4kXbvbwfmQlycav5s7qXe7sY9GSpuaImc1g7dOCkMeta } from "/vercel/path0/pages/manage/permissions/edit/[id].vue?macro=true";
import { default as reset_45passwordQHzcdC_vQeNreJIaB1i820BQBqdgpO4TmDZ8WooHB7wMeta } from "/vercel/path0/pages/students/auth/reset-password.vue?macro=true";
import { default as indexBfPPAUQ8_x7En2eKiTAId8q2_T26ZTc94HoHBdg_x_YMeta } from "/vercel/path0/pages/configure/organizations/index.vue?macro=true";
import { default as index7gM1bk8NJQrkTNGHPxaSrq7PdWqraYzfwI9o2uiaH3QMeta } from "/vercel/path0/pages/manage/annotation/types/index.vue?macro=true";
import { default as add1wTHgzknJnf_aMHmWzVmZF8JMO_45duwViok_45xOQCQQggMeta } from "/vercel/path0/pages/manage/packages/[version]/add.vue?macro=true";
import { default as terms_45and_45conditionswaGkI0EOs_45wnno4QAqf6HmpSlDa5VLA_p_YBzSXP22kMeta } from "/vercel/path0/pages/policies/terms-and-conditions.vue?macro=true";
import { default as statisticsppMevbMiMXloiwqDZbO1FRIMm1q9d0B6k_LBzMFRFpoMeta } from "/vercel/path0/pages/reports/assignment/statistics.vue?macro=true";
import { default as performanceurDmpruSDQmQqszsGi5aOxlTQDCNhOpdC96yCIFQ3_45EMeta } from "/vercel/path0/pages/reports/classroom/performance.vue?macro=true";
import { default as _91id_93AUNF93gV8jbt6CCjy_jJAzBn7dK5GS67TSgQY_453YjwEMeta } from "/vercel/path0/pages/reports/tester/runs/edit/[id].vue?macro=true";
import { default as forgot_45password6TEDOQkIGyZtPgKAF1jPrlHYYkQ951HgQ5HWdxaxp2cMeta } from "/vercel/path0/pages/students/auth/forgot-password.vue?macro=true";
import { default as importi6oSY5FWif4_45T_451TXIn3x0VyUa8RosEhIFJuKPWFgvEMeta } from "/vercel/path0/pages/configure/comments/bulk/import.vue?macro=true";
import { default as indexkT6dgyvFUzLCQSm7p48Ily8Zza_45ATeRrWFC1yud4dlMMeta } from "/vercel/path0/pages/configure/profile/orders/index.vue?macro=true";
import { default as _91id_93p9jexPuLXRXBiVW0ERIrEeKVJcHjHdgLKyn3rJBJYKwMeta } from "/vercel/path0/pages/manage/announcements/edit/[id].vue?macro=true";
import { default as _91id_93xcuKEorT5kofIZg_Em_45vSZCw_45_45ivAvq8ZaaVSfugQNIMeta } from "/vercel/path0/pages/manage/organizations/edit/[id].vue?macro=true";
import { default as loadpcv_S1FuIR4tS5B4LYWzoWpijE1IocfrdfQWgOsZG38Meta } from "/vercel/path0/pages/order/[cartType]/[cartId]/load.vue?macro=true";
import { default as activate_45account8B16dGGYh2AggBNk9at0_h40gn9razF_45gN9ACEI2D5cMeta } from "/vercel/path0/pages/students/auth/activate-account.vue?macro=true";
import { default as cookie_45policyf16yIxr3gSwcUv8nvHuIY8lwGxvdkVAi1wTLU8FnyFEMeta } from "/vercel/path0/pages/students/policies/cookie-policy.vue?macro=true";
import { default as _91id_93p_n6Z5WZJaNB00s_45rzaNHM3TS58Clt0A6NDs51Mp_dIMeta } from "/vercel/path0/pages/manage/criteria/groups/edit/[id].vue?macro=true";
import { default as submit5oDr3yt4D1_451SjdRJFz2KHFkLTfYJcy8zzTZ9nvyzjkMeta } from "/vercel/path0/pages/order/[cartType]/[cartId]/submit.vue?macro=true";
import { default as privacy_45policyM9VCV9z6jkAzECKBMpk5WOlD3_zO15NWBfqcISvCUUcMeta } from "/vercel/path0/pages/students/policies/privacy-policy.vue?macro=true";
import { default as payment_45methodsdkNlj3BtHOdYqLrT_45aohCIWJnXfJ3z2x_45cfu3aebRg0Meta } from "/vercel/path0/pages/configure/profile/payment-methods.vue?macro=true";
import { default as _91id_93EoGtPZITpE_2WqNjJJC1ITWayagf5Y0P_45qLXn8jThhUMeta } from "/vercel/path0/pages/manage/annotation/types/edit/[id].vue?macro=true";
import { default as successumiA0rZqJYbC5q2uWpOI6sXOAAHHKrncwK15dqsKArsMeta } from "/vercel/path0/pages/order/[cartType]/[cartId]/success.vue?macro=true";
import { default as _91version_93YGr8MILDSyaALyxHzUleIV8UtmYqzoiCSJmrZ8IiowgMeta } from "/vercel/path0/pages/manage/capabilities/edit/[version].vue?macro=true";
import { default as checkoutrDnE2I_45mk_45DXuQoI99rbRI4pa2lq2CbaxKIze31NfqgMeta } from "/vercel/path0/pages/order/[cartType]/[cartId]/checkout.vue?macro=true";
import { default as _91id_93n2L4V__CH_45N2mXa1tojB8ZKIfAAZpiJmM7wau0TfDdIMeta } from "/vercel/path0/pages/manage/packages/[version]/edit/[id].vue?macro=true";
import { default as configurexMc1dpz7OqML8Aui0995xFflUWghm9LvohQquPuR6CMMeta } from "/vercel/path0/pages/order/[cartType]/[cartId]/configure.vue?macro=true";
import { default as _91documentId_93_4514sux6CbpMq_45x_45WXPo6dwYoj55LGHyvNdLpJosODM4Meta } from "/vercel/path0/pages/documents/[mode]/review/[documentId].vue?macro=true";
import { default as submitted6e0Wr5zMofiCFeGcKyX0WTAnouc1R9daw7HTFXFygJ0Meta } from "/vercel/path0/pages/students/documents/student/submitted.vue?macro=true";
import { default as addIqsI16E2NSuHVqAHFzJTtTzhfmluwhkYHZa6vaOCb7IMeta } from "/vercel/path0/pages/configure/lms/classroom-templates/add.vue?macro=true";
import { default as terms_45and_45conditionsBxIN3cka7xDzJlWyA5nm92GlvmwiN5EPEAqawZwwbIIMeta } from "/vercel/path0/pages/students/policies/terms-and-conditions.vue?macro=true";
import { default as indexSyCNAf94Mui14pBbRth6D6SCApzoPksEKxhLwe7PL_45wMeta } from "/vercel/path0/pages/configure/lms/classroom-templates/index.vue?macro=true";
import { default as _91id_93qGuFk8D_45nUVp62eqnpCPSsggMjFyyrKoVAxXbm45Y8oMeta } from "/vercel/path0/pages/configure/lms/classroom-templates/edit/[id].vue?macro=true";
import { default as indexzmJPNahrDbFfGKO6vT8KS_ce5XxpTzwMsdK1MjMYYuYMeta } from "/vercel/path0/pages/configure/organizations/edit/[organizationId]/index.vue?macro=true";
import { default as users2xOmkDEcHNgDzwroCJFit_pNlkI_5GIhuhH4_kLQy_UMeta } from "/vercel/path0/pages/configure/organizations/edit/[organizationId]/users.vue?macro=true";
import { default as classroomsFaZyGZmM5ltdJL9MVhYArV1zQAEW3ISWZR3J_FnG6cEMeta } from "/vercel/path0/pages/configure/organizations/edit/[organizationId]/classrooms.vue?macro=true";
import { default as _91organizationId_93a73wqQTXIvj7z9joCyhqSrC4MZRF__fgQgsa_45CGxZ60Meta } from "/vercel/path0/pages/configure/organizations/edit/[organizationId].vue?macro=true";
import { default as _91documentId_93oKmRUw8fBJyEAmGT27UbkVsOnGW_45m5eSWeBgwrQWVB0Meta } from "/vercel/path0/pages/students/documents/student/review/[documentId].vue?macro=true";
import { default as previewHdIw_HpVbrpcFVJZu3eM_GqE72AaV5zn1Wm26_45d13D8Meta } from "/vercel/path0/pages/document/[documentId]/[revisionId]/checklist/preview.vue?macro=true";
export default [
  {
    name: "lms",
    path: "/lms",
    component: () => import("/vercel/path0/pages/lms.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: { ...(homekwnicJK2nHG5PwZCTvdumsTAvd8POoBPlKW0JMmtxqUMeta || {}), ...{"middleware":["public-demo"]} },
    component: () => import("/vercel/path0/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "convert",
    path: "/convert",
    component: () => import("/vercel/path0/pages/convert.vue")
  },
  {
    name: settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta?.name,
    path: "/settings",
    meta: { ...(settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/settings.vue"),
    children: [
  {
    name: "settings",
    path: "",
    component: () => import("/vercel/path0/pages/settings/index.vue")
  },
  {
    name: "settings-reports",
    path: "reports",
    component: () => import("/vercel/path0/pages/settings/reports.vue")
  },
  {
    name: "settings-app-data",
    path: "app-data",
    component: () => import("/vercel/path0/pages/settings/app-data.vue")
  },
  {
    name: "settings-checklists",
    path: "checklists",
    component: () => import("/vercel/path0/pages/settings/checklists.vue")
  },
  {
    name: "settings-lms-finalize",
    path: "lms/finalize",
    meta: { ...(finalizeOxoAV0su_45JhexXF57SjDzo14HGXvZbmjt_45DcfzqVnakMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/settings/lms/finalize.vue")
  }
]
  },
  {
    name: "auth-error",
    path: "/auth/error",
    component: () => import("/vercel/path0/pages/auth/error.vue")
  },
  {
    name: "auth-Login",
    path: "/auth/Login",
    meta: {"middleware":["public-demo"]},
    component: () => import("/vercel/path0/pages/auth/Login.vue")
  },
  {
    name: "auth-oauth",
    path: "/auth/oauth",
    component: () => import("/vercel/path0/pages/auth/oauth.vue")
  },
  {
    name: "auth-Register",
    path: "/auth/Register",
    meta: {"middleware":["public-demo"]},
    component: () => import("/vercel/path0/pages/auth/Register.vue")
  },
  {
    name: "reports-usage",
    path: "/reports/usage",
    meta: usage1T6znCMg7EIfuh2aaszXBlVPFpCr_45oH1yMC12huHWGsMeta || {},
    component: () => import("/vercel/path0/pages/reports/usage.vue")
  },
  {
    name: "students-home",
    path: "/students/home",
    meta: {"middleware":["auth","student-app"]},
    component: () => import("/vercel/path0/pages/students/home.vue"),
    children: [
  {
    name: "students-home-style",
    path: "style",
    component: () => import("/vercel/path0/pages/students/home/style.vue")
  },
  {
    name: "students-home-grades",
    path: "grades",
    component: () => import("/vercel/path0/pages/students/home/grades.vue")
  },
  {
    name: "students-home-resources",
    path: "resources",
    component: () => import("/vercel/path0/pages/students/home/resources.vue")
  },
  {
    name: "students-home-assignments",
    path: "assignments",
    component: () => import("/vercel/path0/pages/students/home/assignments.vue")
  }
]
  },
  {
    name: "admin-lms-test",
    path: "/admin/lms/test",
    meta: { ...(testurvX8agrX0cEObSE_a4_45jLz2VRqPBFYYSBep6eM9_453gMeta || {}), ...{"middleware":["auth","sysadmin","admin"]} },
    component: () => import("/vercel/path0/pages/admin/lms/test.vue")
  },
  {
    name: "articles",
    path: "/articles",
    meta: { ...(index0f8JRB9cR_4501TW1jzlinuL4Z4mObPIqkaQTdKquio18Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/articles/index.vue")
  },
  {
    name: "errors-message",
    path: "/errors/message",
    component: () => import("/vercel/path0/pages/errors/message.vue")
  },
  {
    name: "students-error",
    path: "/students/error",
    component: () => import("/vercel/path0/pages/students/error.vue")
  },
  {
    name: "students",
    path: "/students",
    meta: {"middleware":"student-app"},
    component: () => import("/vercel/path0/pages/students/index.vue")
  },
  {
    name: "test-marketing",
    path: "/test/marketing",
    component: () => import("/vercel/path0/pages/test/marketing.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    meta: { ...(dashboardJLgY_45pk63kzMCm9yuqJ3BxnQlJZRCEqjWncRiulWHP8Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/dashboard.vue")
  },
  {
    name: "auth-demo-login",
    path: "/auth/demo-login",
    component: () => import("/vercel/path0/pages/auth/demo-login.vue")
  },
  {
    name: "manage-roles-add",
    path: "/manage/roles/add",
    meta: {"middleware":["auth","write-user-roles"]},
    component: () => import("/vercel/path0/pages/manage/roles/add.vue")
  },
  {
    name: "reports-problems",
    path: "/reports/problems",
    meta: { ...(problemsZSFncibcFNcL52HeFP4SbChnirhEBOU9Qur5ccx8Sj0Meta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/reports/problems.vue")
  },
  {
    name: "component-library",
    path: "/component-library",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/pages/component-library.vue")
  },
  {
    name: "manage-levels-add",
    path: "/manage/levels/add",
    meta: { ...(addVIhB7E17paUD4BTrjGPsA_45sXEs66wnRFpP_eKFakVAUMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/levels/add.vue")
  },
  {
    name: "auth-refresh-token",
    path: "/auth/refresh-token",
    meta: { ...(refresh_45tokenxcuO5d_8MYhzeJ3a_45Gafkf5BiIMToZ4Yo7YCsCEArz0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/pages/auth/refresh-token.vue")
  },
  {
    name: "configure-password",
    path: "/configure/password",
    meta: { ...(passwordot8NV_Z7AQnysEdPa0lqX8mB_45dVnxlNvY7tl9QptpzcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/password.vue")
  },
  {
    name: "manage-lessons-add",
    path: "/manage/lessons/add",
    meta: { ...(addAjR3ZDpvXqRNjCLKVYy_BgCXUcUJ_4573oAl4tL4ZW5TEMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/lessons/add.vue")
  },
  {
    name: "manage-metrics-add",
    path: "/manage/metrics/add",
    meta: { ...(add0NUv_45bA_gff835ClTgGkaJ8RrrnhI5J8pMojZVLe3OkMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/metrics/add.vue")
  },
  {
    name: "manage-roles",
    path: "/manage/roles",
    meta: {"middleware":["auth","write-user-roles"]},
    component: () => import("/vercel/path0/pages/manage/roles/index.vue")
  },
  {
    name: "manage-users",
    path: "/manage/users",
    meta: indexWFdZJu__45GT6esiGMQt1wqub8Vbq56VoXCI_M2fG2C8oMeta || {},
    component: () => import("/vercel/path0/pages/manage/users/index.vue")
  },
  {
    name: "reports-link-users",
    path: "/reports/link-users",
    meta: {"middleware":["auth","app","sysadmin"]},
    component: () => import("/vercel/path0/pages/reports/link-users.vue")
  },
  {
    name: "welcome-onboarding",
    path: "/welcome/onboarding",
    meta: { ...(onboarding6SaNHboq7muZ2lsRJardKRtH3SHlniGxvjnOwhphNeoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/welcome/onboarding.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: {"middleware":["public-demo"]},
    component: () => import("/vercel/path0/pages/auth/reset-password.vue")
  },
  {
    name: "manage-articles-add",
    path: "/manage/articles/add",
    meta: { ...(addsCT8E3v1GA8ILeJltu_45DQmOxom9r4YvCG4mlEEtWdIoMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/articles/add.vue")
  },
  {
    name: "manage-comments-add",
    path: "/manage/comments/add",
    meta: { ...(addka8A1w5o62iYaJONmvxBQuq9yiJgLlpBOWERM7MrVx8Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/comments/add.vue")
  },
  {
    name: "manage-criteria-add",
    path: "/manage/criteria/add",
    meta: { ...(addXKB68OlpyS0k_rI5uERXxS3H5DFTi7YFsPk_l3MmfpEMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/manage/criteria/add.vue")
  },
  {
    name: "manage-levels",
    path: "/manage/levels",
    meta: { ...(indexZa97_5HcIX4LKi4lYz23Jnjp4RmYlX2AlYMOCTfuSuMMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/levels/index.vue")
  },
  {
    name: "manage-products-add",
    path: "/manage/products/add",
    meta: { ...(addokFZD7xfB9jRcDDku4lJEEWe87K_Er7Mten67CoxxJEMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/manage/products/add.vue")
  },
  {
    name: "oauth-finalize-zoom",
    path: "/oauth/finalize/zoom",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/oauth/finalize/zoom.vue")
  },
  {
    name: "reports-submissions",
    path: "/reports/submissions",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/reports/submissions.vue")
  },
  {
    name: "reports-tester-jira",
    path: "/reports/tester/jira",
    meta: { ...(jira7pjEDJ_Qt5_hXfUwILL874iKcenvo07vr52X_45uV6DoMMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/reports/tester/jira.vue")
  },
  {
    name: "students-auth-login",
    path: "/students/auth/login",
    component: () => import("/vercel/path0/pages/students/auth/login.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: {"middleware":["public-demo"]},
    component: () => import("/vercel/path0/pages/auth/forgot-password.vue")
  },
  {
    name: "configure-curriculum",
    path: "/configure/curriculum",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/configure/curriculum.vue")
  },
  {
    name: "configure-lms-choose",
    path: "/configure/lms/choose",
    meta: { ...(chooseiClGVBlUpLEYMrxQfwo9S1Sq0tRZUpvzax_451GqflXq8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/lms/choose.vue")
  },
  {
    name: "configure-quick-keys",
    path: "/configure/quick-keys",
    meta: { ...(quick_45keysv64l_45LGmR7hZkgDnA065wul7ByyZoFltlpiDtq1qt7EMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/quick-keys.vue")
  },
  {
    name: "level-documents-id",
    path: "/level/documents/:id()",
    meta: { ...(_91id_93Z_sAvV0Pgt0unGUiCl9ssraKOTLulehICY_45NpzoI6UUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/level/documents/[id].vue")
  },
  {
    name: "manage-lessons",
    path: "/manage/lessons",
    meta: { ...(indexl19Lew7I67g7rkQ6LfIa0_sWvnFWpQ8PU_45EhnrrExpYMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/lessons/index.vue")
  },
  {
    name: "manage-metrics",
    path: "/manage/metrics",
    meta: { ...(indexbpIe6nP8Lix0rOnAmJhZ_f86PHLQn4M7YUpirn7JpAsMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/metrics/index.vue")
  },
  {
    name: "manage-packages-list",
    path: "/manage/packages/list",
    meta: { ...(listc_i9WXhzbDO6igKJf3GmmZjXY4E6C8GacjL6elW3RWAMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/manage/packages/list.vue"),
    children: [
  {
    name: "manage-packages-list-version",
    path: ":version()",
    component: () => import("/vercel/path0/pages/manage/packages/list/[version].vue")
  }
]
  },
  {
    name: "reports-tester",
    path: "/reports/tester",
    meta: { ...(indexn3oK4ali6sCHe_45u7OwDokkY0SopZNm1uyHH47mD5JaAMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/reports/tester/index.vue")
  },
  {
    name: "auth-activate-account",
    path: "/auth/activate-account",
    component: () => import("/vercel/path0/pages/auth/activate-account.vue")
  },
  {
    name: "classrooms-emails-add",
    path: "/classrooms/emails/add",
    meta: { ...(addHjGerNpUuChDBRHlqEU03KZrG_uD1yUScJyoVlALmNwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/classrooms/emails/add.vue")
  },
  {
    name: "manage-articles",
    path: "/manage/articles",
    meta: { ...(indexwUpHcLdZBGXI65v0jMuZV_4598xAQI2auH9DNIKnxTt7gMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/articles/index.vue")
  },
  {
    name: "manage-checklists-add",
    path: "/manage/checklists/add",
    meta: { ...(add8wTx235yPPHsOnti7ebvXor5TETrE6aF4LnJqgyvmoUMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/checklists/add.vue")
  },
  {
    name: "manage-comments",
    path: "/manage/comments",
    meta: { ...(indexyfHqh3DUD5bd1_450FSoIZsp2cbQ5uExttMHZUXK4uDNoMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/comments/index.vue")
  },
  {
    name: "manage-criteria",
    path: "/manage/criteria",
    meta: { ...(indexNqi9_leApIqq421W5TeQSRkrL8qgC0_45HRWWk5ov3m_45gMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/criteria/index.vue")
  },
  {
    name: "manage-products",
    path: "/manage/products",
    meta: { ...(index8en8QBb646208GH3HXXJewMhPBi6oVGeRJtKTc_9gm8Meta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/manage/products/index.vue")
  },
  {
    name: "manage-users-userId",
    path: "/manage/users/:userId()",
    meta: _91userId_93RUDktGzDmk3_450m9kDROnhmIeUpkQd4ofOLPw0BJgqBkMeta || {},
    component: () => import("/vercel/path0/pages/manage/users/[userId].vue")
  },
  {
    name: "oauth-finalize-google",
    path: "/oauth/finalize/google",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/oauth/finalize/google.vue")
  },
  {
    name: "configure-comments-add",
    path: "/configure/comments/add",
    meta: { ...(add6yMLCpdhVnZY4bSMj7_45WQxmCfgUVuKmk8MaHQyw0AIgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/comments/add.vue")
  },
  {
    name: "configure-lms-finalize",
    path: "/configure/lms/finalize",
    meta: { ...(finalizejw0cA69nmq4ZBZ7_y2QU6HSUUy2pDrOQBjHog_cnSBIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/lms/finalize.vue")
  },
  {
    name: "configure-subscription",
    path: "/configure/subscription",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/configure/subscription.vue")
  },
  {
    name: "manage-permissions-add",
    path: "/manage/permissions/add",
    meta: {"middleware":["auth","write-user-permissions"]},
    component: () => import("/vercel/path0/pages/manage/permissions/add.vue")
  },
  {
    name: "manage-roles-edit-id",
    path: "/manage/roles/edit/:id()",
    meta: {"middleware":["auth","write-user-roles"]},
    component: () => import("/vercel/path0/pages/manage/roles/edit/[id].vue")
  },
  {
    name: "policies-cookie-policy",
    path: "/policies/cookie-policy",
    component: () => import("/vercel/path0/pages/policies/cookie-policy.vue")
  },
  {
    name: "reports-documents-sync",
    path: "/reports/documents-sync",
    meta: documents_45syncHsxg1vNqlWxR_45X5VDHLGp2eQ9xZ0jesIHgh9h7AIreIMeta || {},
    component: () => import("/vercel/path0/pages/reports/documents-sync.vue")
  },
  {
    name: "admin-checklists-review",
    path: "/admin/checklists/review",
    meta: { ...(reviewt3Hiy5n65qAEvx90SrnqHzyNoF_2a63rj5TNT_wmT_45gMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/checklists/review.vue")
  },
  {
    name: "classrooms-emails",
    path: "/classrooms/emails",
    meta: { ...(indexQs76idwmz_455x2sPlAhQdTBXsTTohHgRDqzjCQ7WV_lEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/classrooms/emails/index.vue")
  },
  {
    name: "manage-capabilities-add",
    path: "/manage/capabilities/add",
    meta: { ...(addiNx6x_458GDgS7puOyvvEWGnZUfUN9aK9htEqr1odEyMkMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/manage/capabilities/add.vue")
  },
  {
    name: "manage-checklists",
    path: "/manage/checklists",
    meta: { ...(indexyoHKv6pKFUaOzaAO0qq_455ILBWxQ8X0i9g7RwLycqauwMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/checklists/index.vue")
  },
  {
    name: "manage-dictionary-words",
    path: "/manage/dictionary/words",
    meta: { ...(wordsQ4wqTXfDQCUyYLbnceR9FfYvtrxKsEhF9QAgH_45mEtjYMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/dictionary/words.vue")
  },
  {
    name: "manage-levels-edit-id",
    path: "/manage/levels/edit/:id()",
    meta: { ...(_91id_933Y6MccyOQkxDhNF9iJkIFQiDd3jUDu31IXNzNpcKMTkMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/levels/edit/[id].vue")
  },
  {
    name: "order-cartType-create",
    path: "/order/:cartType()/create",
    meta: { ...(createWQQ904WlktS_459GQ_D4lRBKTLqyWseXA_455tT8j7X7jLQMeta || {}), ...{"middleware":["auth","cart"]} },
    component: () => import("/vercel/path0/pages/order/[cartType]/create.vue")
  },
  {
    name: "policies-privacy-policy",
    path: "/policies/privacy-policy",
    component: () => import("/vercel/path0/pages/policies/privacy-policy.vue")
  },
  {
    name: "reports-billing-history",
    path: "/reports/billing-history",
    meta: { ...(billing_45history_458SFawUaLZblqnh3NjhIZiH0A4l9IfZQSxz5s9DDD1EMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/reports/billing-history.vue")
  },
  {
    name: "reports-tester-runs-add",
    path: "/reports/tester/runs/add",
    meta: { ...(addA2AQTKRM0rTXEv5_458p_452Xi7VJaRyOI_45zdj08uRFAgGoMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/reports/tester/runs/add.vue")
  },
  {
    name: "classrooms-classroomId",
    path: "/classrooms/:classroomId()",
    meta: {"middleware":["auth","classrooms"]},
    component: () => import("/vercel/path0/pages/classrooms/[classroomId].vue"),
    children: [
  {
    name: "classrooms-classroomId-students",
    path: "students",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/students.vue"),
    children: [
  {
    name: "classrooms-classroomId-students-studentId",
    path: ":studentId()",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/students/[studentId].vue")
  }
]
  },
  {
    name: "classrooms-classroomId-emails-add",
    path: "emails/add",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/emails/add.vue")
  },
  {
    name: "classrooms-classroomId-assignments",
    path: "assignments",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/assignments.vue"),
    children: [
  {
    name: "classrooms-classroomId-assignments-assignmentId",
    path: ":assignmentId()",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/assignments/[assignmentId].vue")
  }
]
  },
  {
    name: "classrooms-classroomId-style",
    path: "style",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/style/index.vue")
  },
  {
    name: "classrooms-classroomId-emails",
    path: "emails",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/emails/index.vue")
  },
  {
    name: "classrooms-classroomId-class-sessions",
    path: "class-sessions",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/class-sessions.vue"),
    children: [
  {
    name: "classrooms-classroomId-class-sessions-classSessionId",
    path: ":classSessionId()",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/class-sessions/[classSessionId].vue")
  }
]
  },
  {
    name: "classrooms-classroomId-gradebook",
    path: "gradebook",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/gradebook/index.vue")
  },
  {
    name: "classrooms-classroomId-resources",
    path: "resources",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/resources/index.vue")
  },
  {
    name: "classrooms-classroomId-emails-edit-emailId",
    path: "emails/edit/:emailId()",
    meta: { ...(_91emailId_93_457Rfsm1lqZDoVObbpI8HQLt2T0p0nHAnOcyXdkq1afUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/emails/edit/[emailId].vue")
  },
  {
    name: "classrooms-classroomId-report-card-studentId",
    path: "report-card/:studentId()",
    component: () => import("/vercel/path0/pages/classrooms/[classroomId]/report-card/[studentId].vue")
  }
]
  },
  {
    name: "configure-classrooms-add",
    path: "/configure/classrooms/add",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/configure/classrooms/add.vue")
  },
  {
    name: "configure-comments",
    path: "/configure/comments",
    meta: { ...(index6gQvK4fhvfGS7yyhKFliSbBaeZZxJTfQKlVi3EaUJHgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/comments/index.vue")
  },
  {
    name: "configure-lms-classrooms",
    path: "/configure/lms/classrooms",
    meta: { ...(classroomspTH9dpol6RPz4VLOFI28zg5TzsWNMX7D4l43VQJw4ooMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/lms/classrooms.vue")
  },
  {
    name: "manage-announcements-add",
    path: "/manage/announcements/add",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/pages/manage/announcements/add.vue")
  },
  {
    name: "manage-comments-bulk-add",
    path: "/manage/comments/bulk/add",
    meta: { ...(add6J0289TplDppvvT3K2NEvp2tbnGiatE_XhNCX_456KR_oMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/comments/bulk/add.vue")
  },
  {
    name: "manage-lessons-edit-id",
    path: "/manage/lessons/edit/:id()",
    meta: { ...(_91id_93Roe_ui8_45VaSXMZ0vF_9Xl6cQWvMP_45pe9YnIsHxxqxiQMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/lessons/edit/[id].vue")
  },
  {
    name: "manage-metrics-edit-id",
    path: "/manage/metrics/edit/:id()",
    meta: { ...(_91id_930UMPcIGC_45uVtpkzgURWVPOeH7SH_45khrieUe7PW1_45LxIMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/metrics/edit/[id].vue")
  },
  {
    name: "manage-organizations-add",
    path: "/manage/organizations/add",
    meta: addGXt0qghALI_45bvwcQdsdqlgCXfr2PocgU_45LMN_vhzSWEMeta || {},
    component: () => import("/vercel/path0/pages/manage/organizations/add.vue")
  },
  {
    name: "manage-permissions",
    path: "/manage/permissions",
    meta: {"middleware":["auth","write-user-permissions"]},
    component: () => import("/vercel/path0/pages/manage/permissions/index.vue")
  },
  {
    name: "reports-user-permissions",
    path: "/reports/user-permissions",
    meta: {"middleware":["auth","sysadmin"]},
    component: () => import("/vercel/path0/pages/reports/user-permissions.vue")
  },
  {
    name: "students-lms-emails-id",
    path: "/students/lms/emails/:id()",
    meta: _91id_93t1GF8TAT9Ui1aYN8TnU5f9oOVPoenBiB23x_45Lbv1Y9gMeta || {},
    component: () => import("/vercel/path0/pages/students/lms/emails/[id].vue")
  },
  {
    name: "articles-view-articleId",
    path: "/articles/view/:articleId()",
    meta: { ...(_91articleId_932jVxkC_AAtIgNjdshakDiEU4ZbpNcHENyhLstC_dhV0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/articles/view/[articleId].vue")
  },
  {
    name: "configure-lms-assignments",
    path: "/configure/lms/assignments",
    meta: { ...(assignmentsn0N58vX6RaujCvRhJq_S7NIr7O77s9_45y7S1XUN6CtpYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/lms/assignments.vue")
  },
  {
    name: "configure-lms-submissions",
    path: "/configure/lms/submissions",
    meta: { ...(submissionsts_456AIuCXNq1erYfwLueqYdZGymLfgtiJjoFJiny_y8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/lms/submissions.vue")
  },
  {
    name: "manage-articles-edit-id",
    path: "/manage/articles/edit/:id()",
    meta: { ...(_91id_93hL4qPcpzkg1E3f_7pr6ao4pw63LfjEOlfGiwWhovUqcMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/articles/edit/[id].vue")
  },
  {
    name: "manage-capabilities",
    path: "/manage/capabilities",
    meta: { ...(indexjvPUyAnyvmb4nuC8CGeZwhcxnC1I8QP_yr6I86Gzk9wMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/manage/capabilities/index.vue")
  },
  {
    name: "manage-comments-edit-id",
    path: "/manage/comments/edit/:id()",
    meta: { ...(_91id_93YeGkGJL5mP_459I_458FyvoxOVODlq67EP273C4sLUGYEVEMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/comments/edit/[id].vue")
  },
  {
    name: "manage-criteria-edit-id",
    path: "/manage/criteria/edit/:id()",
    meta: { ...(_91id_93xKfKSDJO_45hcbvwsFZJ670dmr0QHFfwGL0TK9HGDsN0YMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/criteria/edit/[id].vue")
  },
  {
    name: "manage-products-edit-id",
    path: "/manage/products/edit/:id()",
    meta: { ...(_91id_93G_45yVh7zoSFnJqv9p0jWeYFxnMLXTPb307XUv__45HcMygMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/manage/products/edit/[id].vue")
  },
  {
    name: "reports-subscriber-health",
    path: "/reports/subscriber-health",
    meta: subscriber_45healthJRCyxObp2RJJxQzaCODX2rjDRdyLQsVjBrY6AxTFhykMeta || {},
    component: () => import("/vercel/path0/pages/reports/subscriber-health.vue")
  },
  {
    name: "reports-tester-runs",
    path: "/reports/tester/runs",
    meta: { ...(indexWCVYEjFOeechjMVXhYhqLgAduc0DNarI5sd0ljoForsMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/reports/tester/runs/index.vue")
  },
  {
    name: "students-activate-token",
    path: "/students/activate/:token()",
    component: () => import("/vercel/path0/pages/students/activate/[token].vue")
  },
  {
    name: "configure-dictionary-words",
    path: "/configure/dictionary/words",
    meta: { ...(words3K4w32mSGxoI54Yj_45AezzPbDm2FEpIg0jt6sXRxHMc0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/dictionary/words.vue")
  },
  {
    name: "documents-mode-submitted",
    path: "/documents/:mode()/submitted",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/documents/[mode]/submitted.vue")
  },
  {
    name: "manage-announcements",
    path: "/manage/announcements",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/pages/manage/announcements/index.vue")
  },
  {
    name: "manage-criteria-groups-add",
    path: "/manage/criteria/groups/add",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/pages/manage/criteria/groups/add.vue")
  },
  {
    name: "manage-organizations",
    path: "/manage/organizations",
    meta: indexN6SD7GAOiDAmUJ_45D3ZPXMFAzezeHkiJuFLmE4SNwP08Meta || {},
    component: () => import("/vercel/path0/pages/manage/organizations/index.vue")
  },
  {
    name: "classrooms-emails-id-edit",
    path: "/classrooms/emails/:id()/edit",
    meta: { ...(edit2GSx39OVQwSE2UjsxDhJjL0soWmr6FkZWSveOtZcEVQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/classrooms/emails/[id]/edit.vue")
  },
  {
    name: "configure-comments-bulk-add",
    path: "/configure/comments/bulk/add",
    meta: { ...(addJzMcDkaTgNSEwFvpDW_452rRGAIsyoAadhkBR_puYCIfkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/comments/bulk/add.vue")
  },
  {
    name: "manage-annotation-types-add",
    path: "/manage/annotation/types/add",
    meta: { ...(addqZxdF8xxC5IqHq3TbYKw2sOKU79JGYuSPPqr_45Zb_45z9UMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/annotation/types/add.vue")
  },
  {
    name: "manage-checklists-edit-id",
    path: "/manage/checklists/edit/:id()",
    meta: { ...(_91id_93Aha5NFd4KXQPfrI_t7fllvnkKHbfkkUrmdl6bnG4oIsMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/checklists/edit/[id].vue")
  },
  {
    name: "configure-comments-id-edit",
    path: "/configure/comments/:id()/edit",
    meta: { ...(edit1RNYAhM5wOE82zw1349er2beg6kTn9GZbo5GuVdiBLAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/comments/[id]/edit.vue")
  },
  {
    name: "manage-criteria-groups",
    path: "/manage/criteria/groups",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/pages/manage/criteria/groups/index.vue")
  },
  {
    name: "manage-permissions-edit-id",
    path: "/manage/permissions/edit/:id()",
    meta: {"middleware":["auth","write-user-permissions"]},
    component: () => import("/vercel/path0/pages/manage/permissions/edit/[id].vue")
  },
  {
    name: "students-auth-reset-password",
    path: "/students/auth/reset-password",
    component: () => import("/vercel/path0/pages/students/auth/reset-password.vue")
  },
  {
    name: "configure-organizations",
    path: "/configure/organizations",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/configure/organizations/index.vue")
  },
  {
    name: "manage-annotation-types",
    path: "/manage/annotation/types",
    meta: { ...(index7gM1bk8NJQrkTNGHPxaSrq7PdWqraYzfwI9o2uiaH3QMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/annotation/types/index.vue")
  },
  {
    name: "manage-packages-version-add",
    path: "/manage/packages/:version()/add",
    meta: { ...(add1wTHgzknJnf_aMHmWzVmZF8JMO_45duwViok_45xOQCQQggMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/manage/packages/[version]/add.vue")
  },
  {
    name: "policies-terms-and-conditions",
    path: "/policies/terms-and-conditions",
    component: () => import("/vercel/path0/pages/policies/terms-and-conditions.vue")
  },
  {
    name: "reports-assignment-statistics",
    path: "/reports/assignment/statistics",
    meta: { ...(statisticsppMevbMiMXloiwqDZbO1FRIMm1q9d0B6k_LBzMFRFpoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/reports/assignment/statistics.vue")
  },
  {
    name: "reports-classroom-performance",
    path: "/reports/classroom/performance",
    meta: { ...(performanceurDmpruSDQmQqszsGi5aOxlTQDCNhOpdC96yCIFQ3_45EMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/reports/classroom/performance.vue")
  },
  {
    name: "reports-tester-runs-edit-id",
    path: "/reports/tester/runs/edit/:id()",
    meta: { ...(_91id_93AUNF93gV8jbt6CCjy_jJAzBn7dK5GS67TSgQY_453YjwEMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/reports/tester/runs/edit/[id].vue")
  },
  {
    name: "students-auth-forgot-password",
    path: "/students/auth/forgot-password",
    component: () => import("/vercel/path0/pages/students/auth/forgot-password.vue")
  },
  {
    name: "configure-comments-bulk-import",
    path: "/configure/comments/bulk/import",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/configure/comments/bulk/import.vue")
  },
  {
    name: "configure-profile-orders",
    path: "/configure/profile/orders",
    meta: { ...(indexkT6dgyvFUzLCQSm7p48Ily8Zza_45ATeRrWFC1yud4dlMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/profile/orders/index.vue")
  },
  {
    name: "manage-announcements-edit-id",
    path: "/manage/announcements/edit/:id()",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/pages/manage/announcements/edit/[id].vue")
  },
  {
    name: "manage-organizations-edit-id",
    path: "/manage/organizations/edit/:id()",
    meta: _91id_93xcuKEorT5kofIZg_Em_45vSZCw_45_45ivAvq8ZaaVSfugQNIMeta || {},
    component: () => import("/vercel/path0/pages/manage/organizations/edit/[id].vue")
  },
  {
    name: "order-cartType-cartId-load",
    path: "/order/:cartType()/:cartId()/load",
    meta: { ...(loadpcv_S1FuIR4tS5B4LYWzoWpijE1IocfrdfQWgOsZG38Meta || {}), ...{"middleware":["auth","cart"]} },
    component: () => import("/vercel/path0/pages/order/[cartType]/[cartId]/load.vue")
  },
  {
    name: "students-auth-activate-account",
    path: "/students/auth/activate-account",
    component: () => import("/vercel/path0/pages/students/auth/activate-account.vue")
  },
  {
    name: "students-policies-cookie-policy",
    path: "/students/policies/cookie-policy",
    component: () => import("/vercel/path0/pages/students/policies/cookie-policy.vue")
  },
  {
    name: "manage-criteria-groups-edit-id",
    path: "/manage/criteria/groups/edit/:id()",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/pages/manage/criteria/groups/edit/[id].vue")
  },
  {
    name: "order-cartType-cartId-submit",
    path: "/order/:cartType()/:cartId()/submit",
    meta: { ...(submit5oDr3yt4D1_451SjdRJFz2KHFkLTfYJcy8zzTZ9nvyzjkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/order/[cartType]/[cartId]/submit.vue")
  },
  {
    name: "students-policies-privacy-policy",
    path: "/students/policies/privacy-policy",
    component: () => import("/vercel/path0/pages/students/policies/privacy-policy.vue")
  },
  {
    name: "configure-profile-payment-methods",
    path: "/configure/profile/payment-methods",
    meta: { ...(payment_45methodsdkNlj3BtHOdYqLrT_45aohCIWJnXfJ3z2x_45cfu3aebRg0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/configure/profile/payment-methods.vue")
  },
  {
    name: "manage-annotation-types-edit-id",
    path: "/manage/annotation/types/edit/:id()",
    meta: { ...(_91id_93EoGtPZITpE_2WqNjJJC1ITWayagf5Y0P_45qLXn8jThhUMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/manage/annotation/types/edit/[id].vue")
  },
  {
    name: "order-cartType-cartId-success",
    path: "/order/:cartType()/:cartId()/success",
    meta: { ...(successumiA0rZqJYbC5q2uWpOI6sXOAAHHKrncwK15dqsKArsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/order/[cartType]/[cartId]/success.vue")
  },
  {
    name: "manage-capabilities-edit-version",
    path: "/manage/capabilities/edit/:version()",
    meta: { ...(_91version_93YGr8MILDSyaALyxHzUleIV8UtmYqzoiCSJmrZ8IiowgMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/manage/capabilities/edit/[version].vue")
  },
  {
    name: "order-cartType-cartId-checkout",
    path: "/order/:cartType()/:cartId()/checkout",
    meta: { ...(checkoutrDnE2I_45mk_45DXuQoI99rbRI4pa2lq2CbaxKIze31NfqgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/order/[cartType]/[cartId]/checkout.vue")
  },
  {
    name: "manage-packages-version-edit-id",
    path: "/manage/packages/:version()/edit/:id()",
    meta: { ...(_91id_93n2L4V__CH_45N2mXa1tojB8ZKIfAAZpiJmM7wau0TfDdIMeta || {}), ...{"middleware":["auth","sysadmin"]} },
    component: () => import("/vercel/path0/pages/manage/packages/[version]/edit/[id].vue")
  },
  {
    name: "order-cartType-cartId-configure",
    path: "/order/:cartType()/:cartId()/configure",
    meta: { ...(configurexMc1dpz7OqML8Aui0995xFflUWghm9LvohQquPuR6CMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/order/[cartType]/[cartId]/configure.vue")
  },
  {
    name: "documents-mode-review-documentId",
    path: "/documents/:mode()/review/:documentId()",
    meta: { ...(_91documentId_93_4514sux6CbpMq_45x_45WXPo6dwYoj55LGHyvNdLpJosODM4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/documents/[mode]/review/[documentId].vue")
  },
  {
    name: "students-documents-student-submitted",
    path: "/students/documents/student/submitted",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/students/documents/student/submitted.vue")
  },
  {
    name: "configure-lms-classroom-templates-add",
    path: "/configure/lms/classroom-templates/add",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/configure/lms/classroom-templates/add.vue")
  },
  {
    name: "students-policies-terms-and-conditions",
    path: "/students/policies/terms-and-conditions",
    component: () => import("/vercel/path0/pages/students/policies/terms-and-conditions.vue")
  },
  {
    name: "configure-lms-classroom-templates",
    path: "/configure/lms/classroom-templates",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/configure/lms/classroom-templates/index.vue")
  },
  {
    name: "configure-lms-classroom-templates-edit-id",
    path: "/configure/lms/classroom-templates/edit/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/configure/lms/classroom-templates/edit/[id].vue")
  },
  {
    name: _91organizationId_93a73wqQTXIvj7z9joCyhqSrC4MZRF__fgQgsa_45CGxZ60Meta?.name,
    path: "/configure/organizations/edit/:organizationId()",
    meta: _91organizationId_93a73wqQTXIvj7z9joCyhqSrC4MZRF__fgQgsa_45CGxZ60Meta || {},
    component: () => import("/vercel/path0/pages/configure/organizations/edit/[organizationId].vue"),
    children: [
  {
    name: "configure-organizations-edit-organizationId",
    path: "",
    component: () => import("/vercel/path0/pages/configure/organizations/edit/[organizationId]/index.vue")
  },
  {
    name: "configure-organizations-edit-organizationId-users",
    path: "users",
    component: () => import("/vercel/path0/pages/configure/organizations/edit/[organizationId]/users.vue")
  },
  {
    name: "configure-organizations-edit-organizationId-classrooms",
    path: "classrooms",
    component: () => import("/vercel/path0/pages/configure/organizations/edit/[organizationId]/classrooms.vue")
  }
]
  },
  {
    name: "students-documents-student-review-documentId",
    path: "/students/documents/student/review/:documentId()",
    meta: { ...(_91documentId_93oKmRUw8fBJyEAmGT27UbkVsOnGW_45m5eSWeBgwrQWVB0Meta || {}), ...{"middleware":["auth","student-app"]} },
    component: () => import("/vercel/path0/pages/students/documents/student/review/[documentId].vue")
  },
  {
    name: "document-documentId-revisionId-checklist-preview",
    path: "/document/:documentId()/:revisionId()/checklist/preview",
    component: () => import("/vercel/path0/pages/document/[documentId]/[revisionId]/checklist/preview.vue")
  }
]